import React from "react";
import { DripCampaignModal } from "pages/campaigns/components";
import {
  PrimaryButton,
  SecondaryButton,
  ButtonSizeOptions,
  InputText
} from "@loanbossinc/component-library";
import styled from "styled-components";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-content: center;
  gap: 1em;
`;

const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 1em;
`;

const EditCampaignNameModal = ({
  isOpen,
  onCancelClicked: handleOnCancelClicked,
  onSaveClicked: handleOnSaveClicked,
  editedCampaignName,
  setEditedCampaignName
}) => (
  <DripCampaignModal
    isOpen={isOpen}
    maxWidth={false}
    title="Campaign Name"
    minHeight={1}
    PaperProps={{ style: { width: "480px" } }}
  >
    <Wrapper>
      <InputText
        variant="standard"
        name="campaignNameEditModal"
        type="text"
        onChange={e => setEditedCampaignName(e.target.value)}
        value={editedCampaignName}
      />
      <Footer>
        <SecondaryButton
          label="Cancel"
          size={ButtonSizeOptions.smFluid}
          style={{ width: 132 }}
          onClick={handleOnCancelClicked}
        />
        <PrimaryButton
          label="Save"
          size={ButtonSizeOptions.smFluid}
          onClick={handleOnSaveClicked}
          style={{ width: 132 }}
        />
      </Footer>
    </Wrapper>
  </DripCampaignModal>
);

export default EditCampaignNameModal;

